// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const isUsersSubscriptionGroupDoubleOptInEnabledResult = objectOf({
  double_opt_in_enabled: boolean,
});
